<template>
    <div>
        <div style="display: flex; gap: 10px;">
            <div style="flex: 1;">
                <div>{{ $t('AppAlertsCoaAlertsConfigForm.Código do Alerta') }}</div>
                <InputText style="width: 100%; height: 40px;" v-model="form['code_alert']" 
                    :class="{'p-invalid': $v.form.code_alert.$error && $v.form.code_alert.$dirty}" />
            </div>
            <div style="flex: 1;">
                <div>{{ $t('AppAlertsCoaAlertsConfigForm.Sensores') }}</div>
                <MultiSelect v-model="form['sensors_list']" :options="newOptionsSensors" :filter="true" dataKey="id"
                    style="width: 100%; height: 40px; max-width: 276px;" :showClear="true" optionLabel="parameter"
                    :class="{'p-invalid': $v.form.sensors_list.$error && $v.form.sensors_list.$dirty}" />
                <small style="display: block; margin-top: 4px; color: #6c757d;">{{ $t('AppAlertsCoaAlertsConfigForm.Selecione no mínimo dois sensores') }}</small>
            </div>
            <div style="flex: 1;">
                <div>{{ $t('AppAlertsCoaAlertsConfigForm.Nível Criticidade') }}</div>
                <Dropdown v-model="form['criticality_level']" :options="optionsCriticalityLevel" :filter="true"
                        style="width: 100%; height: 40px; max-width: 276px;" :showClear="true" optionLabel="code" optionValue="code"
                        :class="{'p-invalid': $v.form.criticality_level.$error && $v.form.criticality_level.$dirty}">
                    <template #value="slotProps">
                        <span :class="'badge criticalityLevel-' + slotProps.value" style="margin-right: 5px;">
                            {{ getCriticalityLevel(slotProps.value) }}
                        </span>
                    </template>
                    <template #option="slotProps">
                        <span :class="'badge criticalityLevel-' + slotProps.option.code">
                            {{ getCriticalityLevel(slotProps.option.code) }}
                        </span>
                    </template>
                </Dropdown>
            </div>
        </div>

        <div style="display: flex; gap: 10px; margin-top: 10px;">
            <div style="flex: 1;">
                <div>{{ $t('AppAlertsCoaAlertsConfigForm.Fabricante') }}</div>
                <Dropdown v-model="form['manufacturer_id']" :options="optionsManufacturers" :filter="true" :dataKey="'id'"
                    style="width: 100%; height: 40px; max-width: 276px;" :showClear="true" optionLabel="name" optionValue="id"
                    :class="{'p-invalid': $v.form.manufacturer_id.$error && $v.form.manufacturer_id.$dirty}" />
            </div>
            <div style="flex: 1;">
                <div>{{ $t('AppAlertsCoaAlertsConfigForm.Modelo') }}</div>
                <Dropdown v-model="form['vehicles_manufacturer_models_id']" :options="optionsVehicles" :filter="true"
                    style="width: 100%; height: 40px; max-width: 276px;" optionLabel="name" optionValue="id"
                    :disabled="!this.form.manufacturer_id" :dataKey="'id'"
                    :class="{'p-invalid': $v.form.vehicles_manufacturer_models_id.$error && $v.form.vehicles_manufacturer_models_id.$dirty}" />
            </div>
            <div style="flex: 1;">
                <div>{{ $t('AppAlertsCoaAlertsConfigForm.Status') }}</div>
                <Dropdown v-model="form['status']" :options="optionsStatus" :filter="true"
                        style="width: 100%; height: 40px; max-width: 276px;" :showClear="true" optionLabel="code" optionValue="code"
                        :class="{'p-invalid': $v.form.status.$error && $v.form.status.$dirty}">
                    <template #value="slotProps">
                        <span :class="'badge statusAlert-' + slotProps.value" style="margin-right: 5px;">
                            {{ getStatus(slotProps.value) }}
                        </span>
                    </template>
                    <template #option="slotProps">
                        <span :class="'badge statusAlert-' + slotProps.option.code">
                            {{ getStatus(slotProps.option.code) }}
                        </span>
                    </template>
                </Dropdown>
            </div>
        </div>

        <div style="display: flex; gap: 10px; margin: 10px 0;">
            <div style="flex: 1;">
                <div>{{ $t('AppAlertsCoaAlertsConfigForm.Mensagem de Alerta') }}</div>
                <InputText style="width: 100%; height: 40px;" v-model="form['alert_message']" 
                    :class="{'p-invalid': $v.form.alert_message.$error && $v.form.alert_message.$dirty}" />
            </div>
            <div style="flex: 1;"></div>
            <div style="flex: 1;"></div>
        </div>

        <section v-if="form['sensors_list'] && form['sensors_list'].length >= 2">
            <div v-if="$v.form.sensors_list.$error && $v.form.sensors_list.$dirty" class="p-error">
                {{ $t('AppAlertsCoaAlertsConfigForm.Lista de sensores inválida - Verifique os campos e regras') }}
            </div>
            <TabView>
                <TabPanel v-for="(tab, index) in form['sensors_list']" :key="index" :header="tab.parameter">
                    <div style="display: flex; gap: 10px;">
                        <div style="flex: 1;">
                            <div>{{ $t('AppAlertsCoaAlertsConfigForm.Source') }}</div>
                            <InputNumber v-model="tab.source" style="width: 100%; height: 40px;" />
                            <small style="display: block; margin-top: 4px; color: #6c757d;">{{ $t('AppAlertsCoaAlertsConfigForm.Preencha esse campo caso a source seja obrigatória') }}</small>
                        </div>
                        <div style="flex: 1;">
                            <div>{{ $t('AppAlertsCoaAlertsConfigForm.Valor de Alerta Mínimo Tempo') }}</div>
                            <div class="p-inputgroup" style="width: 100%; height: 40px;">
                                <span class="p-inputgroup-addon">></span>
                                <InputNumber v-model="tab.alert_time" :min="0" />
                                <span class="p-inputgroup-addon">seg</span>
                            </div>
                        </div>
                    </div>

                    <hr style="width: 70px; text-align: center; color: #C7C7C7; padding: 10px 0;">

                    <div style="display: flex; gap: 10px; align-items: center;">
                        <div style="flex: 1; display: flex; gap: 5px;">
                            <Dropdown style="height: 40px; width: 50%;" v-model="tab.rule_first_type" :options="relationalOperators" 
                                optionLabel="label" optionValue="value" />
                            <InputNumber style="height: 40px; width: 50%;" v-model="tab.rule_first_value" mode="decimal" :minFractionDigits="0" :maxFractionDigits="20" />
                        </div>
                        <SelectButton v-model="tab.rule_logical_operator" :options="logicalOperators" optionLabel="label" optionValue="value" />
                        <div style="flex: 1; display: flex; gap: 5px;">
                            <Dropdown style="height: 40px; width: 50%;" v-model="tab.rule_second_type" :options="relationalOperators" 
                                optionLabel="label" optionValue="value" />
                            <InputNumber style="height: 40px; width: 50%;" v-model="tab.rule_second_value" mode="decimal" :minFractionDigits="0" :maxFractionDigits="20"/>
                        </div>
                    </div>
                </TabPanel>
            </TabView>
        </section>

        <div style="float: right;">
            <Button :label="$t('AppAlertsCoaAlertsConfig.Cancelar')" icon="pi pi-times" class="p-button-text p-button-danger" @click="$emit('closeDialog')"/>
            <Button :label="$t('AppAlertsCoaAlertsConfig.Confirmar')" icon="pi pi-check" :disabled="disabledConfirm" class="p-button-text" @click="validate" />
        </div>
    </div>
</template>

<script>
import Button from 'primevue/button/Button';
import Dialog from 'primevue/dialog/Dialog';
import InputText from 'primevue/inputtext/InputText';
import InputNumber from 'primevue/inputnumber';
import Dropdown from 'primevue/dropdown';
import SelectButton from 'primevue/selectbutton';
import {CRITICALY_LEVELS, STATUSES_ALERT} from '../AppOptionsCoa';
import VehiclesManufacturersService from '../../../../services/VehiclesManufacturersService';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import MultiSelect from 'primevue/multiselect';
import {required, helpers} from 'vuelidate/lib/validators';
import AlertsCoaService from '@/services/AlertsCoaService';
import displayToast from '@/mixins/ToastMixin';

const validSensorList = helpers.withParams(
    { type: 'validSensorList' },
    value => {
        if (!Array.isArray(value) || value.length === 0) return false;

        return value.every(sensor => {
        const hasParameter = !!sensor.parameter;
        const hasAlertTime = typeof sensor.alert_time === 'number' && sensor.alert_time > 0;

        const rulesValid =
            ['>', '<', '>=', '<=', '!='].includes(sensor.rule_first_type) &&
            typeof sensor.rule_first_value === 'number' &&
            ['>', '<', '>=', '<=', '!='].includes(sensor.rule_second_type) &&
            typeof sensor.rule_second_value === 'number' &&
            ['E', 'OU'].includes(sensor.rule_logical_operator);

        return hasParameter && hasAlertTime && rulesValid;
        });
    }
);

export default {
    mixins: [displayToast],
    props: {
        optionsManufacturers: {
            type: Array,
        },
        optionsSensors: {
            type: Array,
        },
    },
    data() {
        return {
            form: {},
            optionsCriticalityLevel: CRITICALY_LEVELS,
            optionsStatus: STATUSES_ALERT,
            isNewForm: false,
            optionsVehicles: [],
            relationalOperators: [ 
                { label: this.$t('AppAlertsCoaAlertsConfigForm.> Maior que'), value: '>' },
                { label: this.$t('AppAlertsCoaAlertsConfigForm.< Menor que'), value: '<' },
                { label: this.$t('AppAlertsCoaAlertsConfigForm.>= Maior ou igual a'), value: '>=' },
                { label: this.$t('AppAlertsCoaAlertsConfigForm.<= Menor ou igual a'), value: '<=' },
                { label: this.$t('AppAlertsCoaAlertsConfigForm.!= Diferente de'), value: '!=' }
            ],
            logicalOperators: [
                { label: this.$t('AppAlertsCoaAlertsConfigForm.E'), value: 'E'}, 
                { label: this.$t('AppAlertsCoaAlertsConfigForm.OU'), value: 'OU'}
            ],
            selectedSensorList: [],
            newOptionsSensors: [],
            orgId: null,
            alertsCoaService: null,
            disabledConfirm: false
        }
    },
    created() {
        this.vehiclesManufacturersService = new VehiclesManufacturersService();
        this.alertsCoaService = new AlertsCoaService();
    },
    methods: {
        cleanForm(orgId){
            this.orgId = orgId
            this.isNewForm = true
            this.form = {}
            this.newOptionsSensors = this.optionsSensors.map(sensor => {
                return {
                    ...sensor,
                    rule_first_type: sensor.rules?.rule_first_type ?? '>',
                    rule_first_value: sensor.rules?.rule_first_value ?? null,
                    rule_logical_operator: sensor.rules?.rule_logical_operator ?? 'E',
                    rule_second_type: sensor.rules?.rule_second_type ?? '>',
                    rule_second_value: sensor.rules?.rule_second_value ?? null,
                    alert_time: sensor.rules?.alert_time ?? 0
                };
            });
        },
        editForm(orgId, val){
            this.orgId = orgId
            this.isNewForm = false
            this.newOptionsSensors = []
            this.optionsSensors.forEach(element => {
                let is_sensor = val.sensors_list.find(sensor => sensor.sensor_id === element.id);
                if (is_sensor) {
                    is_sensor.rule_first_value = Number(is_sensor.rule_first_value)
                    is_sensor.rule_second_value = Number(is_sensor.rule_second_value)
                    this.newOptionsSensors.push(is_sensor)
                } else {
                    element.sensor_id = element.id
                    let newElement = {
                        ...element,
                        rule_first_type: '>',
                        rule_first_value: 0,
                        rule_logical_operator: 'E',
                        rule_second_type: '>',
                        rule_second_value: 0,
                        alert_time: 0
                    };
                    this.newOptionsSensors.push(newElement);
                }
            });
            this.form = {}
            this.form = { ...val }
        },
        validate(){
            this.$v.form.$touch();
            if (!this.$v.form.$invalid) {
                if(!this.form.sensors_list || this.form.sensors_list.length < 2){
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfigForm.Por favor preencha todos os campos obrigatórios'), 'e')
                    return
                }
                this.saveCompositeAlert()
            } else {
                this.displayToast(this.$t('AppAlertsCoaAlertsConfigForm.Por favor preencha todos os campos obrigatórios'), 'e')
            }
        },
        saveCompositeAlert() {
            this.disabledConfirm = true
            let form = JSON.parse(JSON.stringify(this.form));
            let id = form.id
            delete form.id
            delete form.vehicle_name
            delete form.vehicle_type
            delete form.type
            delete form.original_type
            delete form.organization_id
            form.sensors_list.forEach(element => {
                if(this.isNewForm){
                    element.sensor_id = element.id
                }
                delete element.id
                delete element.parameter
                delete element.unit
                delete element.system
                delete element.spn
                delete element.organization_id
                delete element.description_spn
                delete element.description
                element.source_is_mandatory = element.source != null ? true : false
            });

            if(this.isNewForm){
                this.createCompositeAlert(form)
                return
            }

            this.editCompositeAlert(form, id)
        },
        createCompositeAlert(form){
            this.alertsCoaService.createCompositeAlert(this.orgId, form).then((data) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Criado com sucesso'), 's')
                    this.$emit('reloadFailures');
                }).catch((error) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Não foi possível criar o alerta'), 'e', error)
                }).finally(() => {
                    this.disabledConfirm = false
                })
        },
        editCompositeAlert(form, id){
            this.alertsCoaService.editCompositeAlert(this.orgId, form, id).then((data) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Editado com sucesso'), 's')
                    this.$emit('reloadFailures');
                }).catch((error) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfig.Não foi possível editar o alerta'), 'e', error)
                }).finally(() => {
                    this.disabledConfirm = false
                })
        },
        getCriticalityLevel(status) {
            let result = this.optionsCriticalityLevel.find(({code}) => code === status);
            if (result) {
                return result.name;
            }
        },
        getStatus(status) {
            let result = this.optionsStatus.find(({code}) => code === status);
            if (result) {
                return result.name;
            }
        }
    },
    watch: {
        'form.manufacturer_id': function (val) {           
            this.vehiclesManufacturersService.findAllModelsByManufacturerId(val)
                .then((data) => {
                    let newData = []
                    data.models.forEach(model => {
                        newData.push({
                            id: model.id,
                            name: model.name
                        })
                    });
                    this.optionsVehicles = newData;
                })
                .catch((error) => {
                    this.displayToast(this.$t('AppAlertsCoaAlertsConfigForm.Não foi possível buscar os modelos'), 'e', error)
                });
        }
    },
    validations: {
        form: {
            code_alert: { required },
            sensors_list: {
                required,
                validSensorList
            },
            vehicles_manufacturer_models_id: { required },
            criticality_level: { required },
            alert_message: { required },
            status: { required },
            manufacturer_id: { required }
        }
    },
    components: {
        Dialog, Button, InputText, Dropdown, InputNumber, SelectButton, TabView, TabPanel, MultiSelect
    }
}
</script>

<style scoped lang="scss">
@import "src/assets/styles/primevue";
@import "src/components/views/alerts-coa/style";
</style>